import { render, staticRenderFns } from "./AnnouncementsNotification.vue?vue&type=template&id=6d531797&"
import script from "./AnnouncementsNotification.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports